import { Col } from 'antd';

interface BorderedColProps {
  children?: any;
  lg?: number;
  md?: number;
  sm?: number;
  span?: number;
  xl?: number;
  xs?: number;
}

const BorderedCol = (props: BorderedColProps) => (
  <Col lg={props.lg} md={props.md} sm={props.sm} span={props.span} xl={props.xl} xs={props.xs}>
    <div style={divStyle}>{props.children}</div>
  </Col>
);

const divStyle = {
  border: 'solid 1px lightgray',
  height: '87%',
  marginBottom: '10px',
  padding: 10,
};

export default BorderedCol;
